var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'a' : 'span',{tag:"component",staticClass:"chip",class:{ 'chip--default': !_vm.color },style:(_vm.style),attrs:{"href":_vm.to || null}},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")]),(_vm.badge)?_c('span',{staticClass:"chip__badge"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }